//
//
//
//
//
//
//
//

export default {
    name: 'CozyGamingPage',

    metaInfo() {
        return {
            title: 'Cozy Gaming Community',
            meta: [{
                vmid: 'description',
                name: 'description',
                content: 'Check out our cozy game VTubing streams on Twitch, and join our cozy gaming Discord community!',
            }],
        }
    },
}
